import { useUserState } from '@juvare/contact-management/ui/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Card, Grid, Tooltip, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import { LinkWithArrow } from '../../../../ui/components/LinkWithArrow';
import { PendingRequests } from '../../../../ui/components/PendingRequests';
import { ShiftRemainingTime } from '../../../../ui/components/ShiftRemainingTime';
import { Slots } from '../../../../ui/components/Slots';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getDefaultMissionsTab } from '../../mission-list';
export const UpcomingShiftBox = ({ shiftId, missionName, missionId, countyName, missionType, totalParticipantSlots, totalApprovedParticipants, totalPendingParticipants, startTime, stopTime, missionRoute, allowMissionChange, }) => {
    const { t } = useMissionsTranslation();
    const userState = useUserState();
    const shiftEndingInSameDay = new Date(startTime).toDateString() === new Date(stopTime).toDateString();
    const defaultMissionsTab = getDefaultMissionsTab(userState);
    const ariaDescribedBy = React.useId();
    return (React.createElement(Card, { sx: {
            overflow: 'hidden',
            mb: 2,
        }, variant: 'outlined', "data-test": `upcomingShift-box-${shiftId}` },
        React.createElement(LinkWithArrow, { to: `${missionRoute}/${missionId}?missionTab=${defaultMissionsTab}`, ariaLabel: t('missions.detailsMissionAriaLabel', { missionName }), ariaDescribedBy: ariaDescribedBy },
            React.createElement(Grid, { id: ariaDescribedBy, container: true, alignItems: 'center', spacing: 3 },
                React.createElement(Grid, { container: true, rowSpacing: 1, size: {
                        md: 12,
                        lg: 6,
                    } },
                    React.createElement(Grid, { container: true, alignItems: 'center', gap: 1, size: 12 },
                        React.createElement(Typography, { variant: 'overline', sx: { color: grey[700] }, "data-test": 'date' }, t('date', { value: startTime })),
                        React.createElement(Typography, { variant: 'overline', sx: { color: grey[300] } }, "|"),
                        React.createElement(Typography, { variant: 'overline', sx: { color: grey[700] }, "data-test": 'time' },
                            t('time', { value: startTime }),
                            " - ",
                            t('time', { value: stopTime })),
                        !shiftEndingInSameDay && (React.createElement(Tooltip, { enterTouchDelay: 0, title: t('missions.shiftEndingNextDayTooltip'), placement: 'bottom-start', "data-test": 'tooltip' },
                            React.createElement(InfoOutlinedIcon, { fontSize: 'small', color: 'primary' })))),
                    React.createElement(Grid, { size: 12 },
                        React.createElement(Typography, { variant: 'h6', sx: { color: grey[900] }, "data-test": 'mission-name' }, missionName)),
                    React.createElement(Grid, { container: true, alignItems: 'center', gap: 1, size: 12 },
                        React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.subtle }, "data-test": 'mission-type' }, missionType),
                        React.createElement(Typography, { variant: 'overline', sx: { color: themeColors.border.main } }, "|"),
                        React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.subtle }, "data-test": 'county' }, countyName))),
                React.createElement(Grid, { container: true, justifyContent: 'space-between', alignItems: 'center', spacing: 3, size: {
                        md: 12,
                        lg: 6,
                    } },
                    React.createElement(Grid, { container: true, gap: 3, size: {
                            sm: 12,
                            md: 'grow',
                        } },
                        React.createElement(Grid, { size: {
                                xs: 12,
                                sm: 'grow',
                            } },
                            React.createElement(Slots, { total: totalParticipantSlots, totalApproved: totalApprovedParticipants })),
                        allowMissionChange && (React.createElement(Grid, { size: {
                                xs: 12,
                                sm: 'grow',
                            } },
                            React.createElement(PendingRequests, { totalPendingParticipants: totalPendingParticipants !== null && totalPendingParticipants !== void 0 ? totalPendingParticipants : 0 })))),
                    React.createElement(Grid, { size: {
                            sm: 12,
                            md: 'auto',
                        } },
                        React.createElement(ShiftRemainingTime, { startTime: startTime })))))));
};
